import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useIsConvelioSupplier } from 'src/app/hooks/useIsConvelioSupplier';

import { translations } from '../../../../../locales/translations';
import { DeliveryMethodType } from '../../../../../types/BookingType';
import { DELIVERY_METHOD_VAN } from '../../../../types/booking/DeliveryMethod';
import HeaderCategory from './HeaderCategory';
import HeaderChip from './HeaderChip';

const WrapperBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'start',
  flexWrap: 'wrap'
});
type Props = {
  deliveryMethod: DeliveryMethodType;
  customerRef: string;
  orderAccountName: string;
  isInsured?: boolean;
  finalDeliveryDate?: string | null;
};

function HeaderFlags({
  deliveryMethod,
  customerRef,
  orderAccountName,
  isInsured,
  finalDeliveryDate
}: Props): JSX.Element {
  const { t } = useTranslation();
  const isConvelioSupplier = useIsConvelioSupplier();
  const isDeliveryMethodVan = DELIVERY_METHOD_VAN.includes(deliveryMethod);
  return (
    <WrapperBoxStyled>
      {isConvelioSupplier && isInsured && (
        <HeaderChip label={t(translations.insured)} color={'success'} />
      )}
      {isConvelioSupplier && finalDeliveryDate && (
        <HeaderChip
          icon={<OutlinedFlagIcon />}
          label={t(translations.finalDelivery)}
          color={'warning'}
        />
      )}
      {isDeliveryMethodVan && (
        <HeaderChip
          label={t(translations.deliveryMethod[deliveryMethod])}
          color={'warning'}
        />
      )}
      {customerRef && (
        <HeaderCategory
          label={`${orderAccountName?.toUpperCase()} - ${customerRef?.toLocaleUpperCase()}`}
        />
      )}
    </WrapperBoxStyled>
  );
}

export default HeaderFlags;
